import { useState, useEffect } from 'react';

const categories = [
  {
    key: 'cabaret',
    label: 'キャバクラ',
    icon: 'ri-star-smile-line',
    items: [
      {
        title: '銀座高級キャバクラ 指名売上トップキャスト誕生',
        description: '自分の写真入りオリジナルボトルをお客様へのプレゼントとして活用。インスタ映えで口コミが広がり、指名数が激増。',
        result: '月間指名数 3倍以上',
        image: 'https://i.ibb.co/JF3jR5BM/orishyan.jpg',
      },
      {
        title: '六本木クラブ 周年記念イベント 特別ボトル制作',
        description: '創業10周年記念に限定デザインボトルを200本制作。イベント当日は完売し、メディアにも取り上げられる話題に。',
        result: 'イベント売上 過去最高記録',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/fcea69b93ca715fce2b758e4255aeb0e.jpeg',
      },
      {
        title: '大阪ミナミ キャバクラ 新人キャスト売上急上昇',
        description: 'デビュー1ヶ月目からオリジナルボトルを活用。お客様への特別感演出でリピーター獲得に成功。',
        result: '初月売上 業界平均の2.5倍',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/b822ddeb03eae0435fbaf684fc2269cb.jpeg',
      },
      {
        title: '名古屋 老舗キャバクラ ブランドリニューアル',
        description: '店舗リニューアルに合わせてオリジナルボトルを全面刷新。高級感のある新デザインで客単価が大幅アップ。',
        result: '客単価 +55%向上',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/574f1dba7ecb7c40b37970378f4e651a.jpeg',
      },
      {
        title: '福岡 天神キャバクラ SNS拡散で新規集客',
        description: 'オリジナルボトルのインスタ投稿がバズり、新規のお客様が急増。フォロワー数も大幅に伸びた。',
        result: 'SNS経由新規来店 月40名超',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/a622f7686515f0f981888dc7223ecc8c.jpeg',
      },
      {
        title: '札幌 すすきの キャバクラ VIP顧客獲得',
        description: '高額VIP顧客向けに特別デザインのオリジナルボトルを制作。特別感の演出でリピート率が大幅向上。',
        result: 'VIPリピート率 +70%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/a19eda2e06146092d2c4b3e6986b0a3d.jpeg',
      },
      {
        title: '横浜 みなとみらい キャバクラ 誕生日演出',
        description: 'お客様の誕生日に名前入りオリジナルボトルをサプライズプレゼント。感動体験でリピーター化に成功。',
        result: '誕生日来店リピート率 +85%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/57e5124598b8b81b54de661b0f7a2a7c.jpeg',
      },
      {
        title: '京都 祇園 高級クラブ 外国人VIP対応',
        description: '英語・中国語対応のオリジナルボトルラベルを制作。インバウンド富裕層顧客の獲得に成功。',
        result: '外国人VIP客 前年比 +120%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/523febede3884b6ad4519a73c70a468d.jpeg',
      },
      {
        title: '仙台 国分町 キャバクラ 周年記念ボトル',
        description: '5周年記念に特別デザインボトルを制作。常連客への感謝を込めたプレゼントとして大好評。',
        result: '常連客満足度 過去最高',
        image: '',
      },
      {
        title: '広島 流川 キャバクラ 新店オープン話題作り',
        description: '新店オープンに合わせてオリジナルボトルを制作。話題性でオープン初日から満席を達成。',
        result: 'オープン初月 予約待ち続出',
        image: '',
      },
      {
        title: '神戸 北野 キャバクラ 高級路線強化',
        description: 'プレミアムデザインのオリジナルボトルで高級路線を強化。富裕層顧客の獲得と客単価向上を実現。',
        result: '客単価 +65%向上',
        image: '',
      },
      {
        title: '東京 銀座 キャバクラ 月間売上記録更新',
        description: 'オリジナルボトルをシャンパンコールに全面導入。LED演出と組み合わせて月間売上の新記録を達成。',
        result: '月間売上 過去最高更新',
        image: '',
      },
    ],
  },
  {
    key: 'host',
    label: 'ホスト',
    icon: 'ri-vip-crown-line',
    items: [
      {
        title: '歌舞伎町No.1ホスト 年間売上1億円突破',
        description: 'オリジナルシャンパンをシャンパンコールに導入。LED演出でお客様の感動を最大化し、SNS拡散で新規指名が急増。',
        result: '売上前年比 +180%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/bc312b1d2d36666d66187db65aa70b40.jpeg',
      },
      {
        title: '新宿歌舞伎町 大手ホストクラブチェーン 全店導入',
        description: '全5店舗にオリジナルボトルを一括導入。統一ブランドイメージの確立と、VIP顧客へのプレミアム体験を実現。',
        result: 'VIP顧客リピート率 +65%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/c8395d9d41e29f2119c5b07612f9effe.jpeg',
      },
      {
        title: '池袋 人気ホスト SNS総フォロワー10万人突破',
        description: 'オリジナルボトルをSNS投稿に活用。ビジュアルインパクトで拡散が加速し、全国からファンが来店。',
        result: 'SNS経由新規来店 月50名超',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/eb60496172a17b4d108667c7703e3cc5.jpeg',
      },
      {
        title: '渋谷 新進気鋭ホスト グループ最速ナンバー1獲得',
        description: 'デビュー3ヶ月でオリジナルボトルを武器に急成長。限定デザインがお客様の収集欲を刺激し継続来店を促進。',
        result: 'デビュー3ヶ月でグループ1位',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/8e7709dd6009f718b576e77e9bac6fcb.jpeg',
      },
      {
        title: '大阪 北新地 ホスト 誕生日イベント大成功',
        description: '自分の誕生日イベントにオリジナルボトルを100本用意。SNSで話題となり過去最高の売上を記録。',
        result: '誕生日イベント売上 過去最高',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/07d8177fdd0ae2c5820f050f3cdcdd88.jpeg',
      },
      {
        title: '名古屋 栄 ホストクラブ 新人ホスト急成長',
        description: 'デビュー直後からオリジナルボトルを活用。特別感のある演出でお客様の心を掴み、急速に指名数を伸ばした。',
        result: '3ヶ月で指名数 5倍増',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/9ebbbf6d69f7d3af33cfc021d9cf81e1.jpeg',
      },
      {
        title: '福岡 中洲 ホスト 限定コレクションボトル展開',
        description: '季節ごとに限定デザインのオリジナルボトルを展開。コレクター心理を刺激し、継続来店率が大幅向上。',
        result: '継続来店率 +90%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/38a708a9d255c5fb469b2d51971a4ca9.jpeg',
      },
      {
        title: '横浜 関内 ホストクラブ グループ売上1位',
        description: 'グループ全体でオリジナルボトルを統一導入。ブランド力の向上とチーム一体感でグループ売上1位を達成。',
        result: 'グループ売上 1位獲得',
        image: '',
      },
      {
        title: '京都 木屋町 ホスト 海外ファン獲得',
        description: '多言語対応のオリジナルボトルラベルで海外ファンの心を掴む。インバウンド需要を取り込み売上が急増。',
        result: '海外ファン来店 月30名超',
        image: '',
      },
      {
        title: '仙台 国分町 ホスト 周年記念特別ボトル',
        description: '活動3周年を記念した特別デザインボトルを制作。ファンへの感謝を込めた演出で感動を呼んだ。',
        result: '周年イベント 満員御礼',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/327e89ab67c862746fcbdb8ccf9e8261.jpeg',
      },
      {
        title: '札幌 ススキノ ホスト SNSバイラル達成',
        description: 'オリジナルボトルのシャンパンコール動画がSNSでバイラル。全国からの新規来店が殺到した。',
        result: 'SNS再生数 100万回超',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/cdf211d69b54c52cc11a4aaa5ab8b76f.jpeg',
      },
      {
        title: '東京 六本木 ホスト 年間MVP受賞',
        description: 'オリジナルボトルを活用した独自の接客スタイルが評価され、グループ年間MVPを受賞。',
        result: 'グループ年間MVP受賞',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/634599caf7fdfeb068edb5a6bb30ddcf.jpeg',
      },
    ],
  },
  {
    key: 'logo',
    label: '店ロゴ',
    icon: 'ri-store-3-line',
    items: [

      {
        title: '恵比寿 ラウンジ 開店記念オリジナルボトル',
        description: '新店オープンに合わせてロゴ入りボトルを制作。オープン初日から話題となりメディア掲載も実現。',
        result: 'オープン初月 満席続き',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/c97733135b1be0c08950814875cc00ad.jpeg',
      },
      {
        title: '銀座 高級クラブ 周年記念限定ボトル',
        description: '創業20周年を記念した特別デザインボトルを制作。常連VIP客へのプレゼントとして喜ばれ、ブランド価値が向上。',
        result: 'VIP顧客満足度 過去最高',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/36d24a740efc4859d016223e7fb869c3.jpeg',
      },
      {
        title: '福岡 人気バー チェーン全店ブランド統一',
        description: '3店舗のブランドイメージを統一したオリジナルボトルを制作。グループ全体の認知度向上とブランド力強化に貢献。',
        result: 'ブランド認知度 大幅向上',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/6f6ce2ab61a1cc631403a10b1077ac4e.jpeg',
      },
      {
        title: '大阪 北新地 高級クラブ ロゴリニューアル',
        description: 'ブランドリニューアルに合わせてロゴ入りボトルも刷新。新デザインで高級感が増し、新規VIP顧客の獲得に成功。',
        result: '新規VIP顧客 +50%増',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/669e3beff3dfd5c3824f31a56ccfc167.jpeg',
      },
      {
        title: '名古屋 錦 ラウンジ 記念日演出強化',
        description: '記念日専用のロゴ入りオリジナルボトルを制作。特別な演出でお客様の感動を最大化し、口コミが急増。',
        result: '記念日予約 前年比 +80%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/7a8a5a6e28f3b9a933ee0439532bac36.jpeg',
      },
      {
        title: '東京 六本木 ナイトクラブ ブランド確立',
        description: 'オリジナルロゴボトルで独自のブランドを確立。メディア露出も増え、国内外からの来客が増加。',
        result: 'メディア掲載 10媒体以上',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/cd288ba298c663d263bd3e1a05173131.jpeg',
      },
      {
        title: '京都 祇園 老舗クラブ 伝統×モダン融合',
        description: '伝統的な和のデザインとモダンを融合したオリジナルボトルを制作。唯一無二のブランドイメージを確立。',
        result: '外国人観光客来店 +200%',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/298deb42dcc708a72ac0e7ddfd7944e6.jpeg',
      },
      {
        title: '横浜 中華街 高級レストラン ギフトボトル',
        description: '特別なギフト用オリジナルボトルを制作。贈り物として大人気となり、新たな収益源を確立。',
        result: 'ギフト売上 月100本超',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/19d17c91eef1687aec9cfaa878bbbdf6.jpeg',
      },
      {
        title: '神戸 北野 ワインバー プレミアム路線',
        description: 'ワインバーのコンセプトに合わせたプレミアムデザインのオリジナルボトルを制作。高級路線の強化に成功。',
        result: '客単価 +75%向上',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/4680931b1857a6c754ea13d3343b3f84.jpeg',
      },
      {
        title: '仙台 国分町 クラブ 開業10周年記念',
        description: '10周年を記念した特別限定ボトルを制作。常連客への感謝と新規顧客獲得を同時に実現。',
        result: '10周年イベント 過去最高動員',
        image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/f753848f9b54aeca8aa7d1d1e3720cf9.jpeg',
      },
      {
        title: '札幌 ススキノ バー 冬季限定ボトル',
        description: '北海道の冬をテーマにした季節限定デザインボトルを制作。希少性と話題性で売上が急増。',
        result: '限定ボトル 即日完売',
        image: 'https://readdy.ai/api/search-image?query=Sapporo%20winter%20themed%20limited%20edition%20champagne%20bottle%2C%20Hokkaido%20snow%20inspired%20label%20design%2C%20seasonal%20exclusive%20product%2C%20luxury%20bar%20winter%20atmosphere%2C%20premium%20limited%20collection%20photography&width=600&height=600&seq=logo-011&orientation=squarish',
      },
    ],
  },
];

export default function AchievementsSection() {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const checkHash = () => {
      const hash = window.location.hash;
      if (hash.includes('tab=host')) {
        const idx = categories.findIndex(c => c.key === 'host');
        if (idx !== -1) setActiveTab(idx);
      } else if (hash.includes('tab=cabaret')) {
        const idx = categories.findIndex(c => c.key === 'cabaret');
        if (idx !== -1) setActiveTab(idx);
      } else if (hash.includes('tab=logo')) {
        const idx = categories.findIndex(c => c.key === 'logo');
        if (idx !== -1) setActiveTab(idx);
      }
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);

  const current = categories[activeTab];

  return (
    <section id="achievements" className="py-24 bg-gradient-to-b from-black to-purple-950/20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-12">
          <span className="inline-block text-yellow-400 text-sm font-bold tracking-widest uppercase mb-4 border border-yellow-400/40 rounded-full px-5 py-1.5">
            &nbsp;works
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            制作実績
          </h2>
          <p className="text-xl text-gray-300">
            全国500店舗以上で選ばれ続けるオリシャン
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white/5 border border-white/10 rounded-full p-1 gap-1">
            {categories.map((cat, idx) => (
              <button
                key={cat.key}
                onClick={() => setActiveTab(idx)}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeTab === idx
                    ? 'bg-yellow-400 text-black shadow-lg shadow-yellow-400/30'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <i className={`${cat.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {current.items.filter(item => item.image).slice(0, 12).map((item, i) => (
            <div
              key={i}
              className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl overflow-hidden border border-purple-500/20 hover:border-yellow-400/50 transition-all duration-500 group"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6 text-sm">あなたのお店でも売上の上がるオリシャンを作りませんか？</p>
          <a
            href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#06C755] hover:bg-[#05b34c] text-white text-lg font-bold px-10 py-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-2xl"></i>
            無料で相談する
          </a>
        </div>
      </div>
    </section>
  );
}
